
export const canInitServiceWorker = () => {
  const canInit = window && 'navigator' in window && 'serviceWorker' in window.navigator && typeof window.navigator.serviceWorker === 'object';
  return canInit;
}